// ErrorFallback.jsx
import React from "react";
import "./styles.css";
import { FormattedMessage, IntlProvider } from "react-intl";
import messages_en from "../../translations/en.json";
import messages_de from "../../translations/de.json";

export default function ErrorFallback({ error, resetErrorBoundary }) {
  const handleRefresh = () => {
    if (resetErrorBoundary) {
      resetErrorBoundary();
    } else {
      window.location.reload();
    }
  };

  const handleGoBack = () => {
    window.history.back();
  };

  React.useEffect(() => {
    console.log("Fallback page loaded at:", new Date().toISOString());
    if (error) {
      console.error("Error details:", error);
    }
  }, [error]);

  return (
    <IntlProvider
      locale={localStorage.getItem("lang") === "de" ? "de" : "en"}
      messages={
        localStorage.getItem("lang") === "de" ? messages_de : messages_en
      }
    >
      <div className="error-fallback">
        <div className="error-fallback__background-pattern" />

        <div className="error-fallback__container">
          <div className="error-fallback__icon-wrapper">
            <div className="error-fallback__icon">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 8v4" />
                <circle cx="12" cy="16" r="0.5" />
              </svg>
            </div>
          </div>

          <h1 className="error-fallback__title">
            <FormattedMessage id="error-fallback.title" />
          </h1>

          <p className="error-fallback__message">
            <FormattedMessage id="error-fallback.message" />
          </p>

          <div className="error-fallback__actions">
            <button
              className="error-fallback__btn error-fallback__btn--primary"
              onClick={handleRefresh}
            >
              <FormattedMessage id="error-fallback.primaryAction" />
            </button>

            <button
              className="error-fallback__btn error-fallback__btn--secondary"
              onClick={handleGoBack}
            >
              <FormattedMessage id="error-fallback.secondryAction" />
            </button>
          </div>

          <p className="error-fallback__support-text">
            <FormattedMessage
              id="error-fallback.supportText"
              defaultMessage="If the problem persists, please <link>contact support</link>"
              values={{
                link: (chunks) => (
                  <a href="mailto:support@eclear.com">{chunks}</a>
                ),
              }}
            />
          </p>
        </div>
      </div>
    </IntlProvider>
  );
}
